import { Form } from "react-bootstrap"
import React from "react"

const LinkedToTab = ({ tickets, setTickets, quantityAvailable }) => {
  const handleTicketSelection = (id) => {
    const selectedTickets = tickets.filter((ticket) => ticket.selected);
    const totalSelectedQuantity = selectedTickets.reduce((sum, ticket) => sum + (ticket.maxQuantity || 0), 0);
    const ticketToToggle = tickets.find((ticket) => ticket.id === id);

    // If trying to select a ticket, check if adding its maxQuantity would exceed the limit
    if (!ticketToToggle.selected && quantityAvailable && totalSelectedQuantity + (ticketToToggle.maxQuantity || 0) > quantityAvailable) {
      return // Don't allow selection if limit would be exceeded
    }

    setTickets(tickets.map((ticket) => (ticket.id === id ? { ...ticket, selected: !ticket.selected } : ticket)));
  }

  const handleQuantityChange = (id, quantity) => {
    const parsedQuantity = Number.parseInt(quantity);
    const otherSelectedTickets = tickets.filter((ticket) => ticket.selected && ticket.id !== id);
    const totalOtherQuantity = otherSelectedTickets.reduce((sum, ticket) => sum + (ticket.maxQuantity || 0), 0);

    // Prevent changing quantity if it would exceed the total quantityAvailable
    if (quantityAvailable && totalOtherQuantity + parsedQuantity > quantityAvailable) {
      return; // Don't allow quantity change if limit would be exceeded
    }

    setTickets(
      tickets.map((ticket) => (ticket.id === id ? { ...ticket, maxQuantity: parsedQuantity } : ticket)),
    );
  }

  const totalLinkedTickets = tickets.filter((ticket) => ticket.selected).reduce((sum, ticket) => sum + (ticket.maxQuantity || 0), 0);
  const isLimitReached = quantityAvailable && totalLinkedTickets >= quantityAvailable; 

  return (
    <div className="linked-to-tab">
      {/* <div className="df_center_div pb-3">
        <div className="pillsContainer">
          <div className="pill">Basic</div>
          <div className="pill activePill">Linked To</div>
        </div>
      </div> */}
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Link add-ons with tickets</h5>
        <span className="text-muted">
          Total {totalLinkedTickets} add-ons linked
          {quantityAvailable && (
            <span className={`ms-2 ${isLimitReached ? "text-warning" : "text-info"}`}>
              ({totalLinkedTickets}/{quantityAvailable} limit)
            </span>
          )}
        </span>
      </div>

      <p className="text-muted mb-4">
        When selecting a ticket, you can also set the maximum quantity of add-ons per attendee
        {quantityAvailable && (
          <span className="d-block mt-2">
            <strong>Note:</strong> You can link up to {quantityAvailable} add-ons based on your quantity available
            setting.
            {isLimitReached && (
              <span className="text-warning ms-1">Limit reached - adjust quantities or unselect a ticket to select another.</span>
            )}
          </span>
        )}
      </p>

      <div className="ticket-list">
        {tickets.length === 0 ? (
          <div>No tickets available to link.</div>
        ) : (
          tickets.map((ticket) => {
            const isDisabled = !ticket.selected && isLimitReached;

            return (
              <div key={ticket.id} className={`ticket-item border_ticket p-2 ${isDisabled ? "opacity-50" : ""}`}>
                <div className="align-items-center row">
                  <div className="col-md-8">
                    <Form.Check
                      type="checkbox"
                      id={`ticket-${ticket.id}`}
                      label={ticket.ticket_name || "Unnamed Ticket"}
                      checked={ticket.selected || false}
                      onChange={() => handleTicketSelection(ticket.id)}
                      className="fw-medium linked_div_checkbox"
                      disabled={isDisabled}
                    />
                     <small className="text-muted ms-4">{isDisabled ?"Cannot select - quantity limit reached":""}</small>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center justify-content-end">
                      <span className="text-muted me-2" style={{ fontSize: "0.875rem" }}>
                        Max. quantity / attendee
                      </span>
                      <div className="quantity-selector">
                        <select
                          className="form-select"
                          value={ticket.maxQuantity || 1}
                          onChange={(e) => handleQuantityChange(ticket.id, e.target.value)}
                          disabled={!ticket.selected}
                          style={{
                            minWidth: "60px",
                            padding: "0.25rem 0.5rem",
                            fontSize: "0.875rem",
                            borderRadius: "4px",
                            border: "1px solid #dee2e6",
                            opacity: ticket.selected ? 1 : 0.6,
                          }}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

export default LinkedToTab